import { useLayoutEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders its children inside the element with the given id when it is
 * mounted (a slot another component leaves in its layout), inline otherwise.
 */
export function PortalSlot({ id, children }: { id: string; children: ReactNode }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  useLayoutEffect(() => {
    setTarget(document.getElementById(id));
  }, [id]);
  return target ? createPortal(children, target) : <>{children}</>;
}
